import { PRODUCT_TYPES } from '@utils/enums';
import { capitalizeFirstLetter } from './string-helpers';
import { getCollectionQueryParam } from './plp-helpers';

const localizedRootUrl = () => {
	const firstParam = window.location.pathname.replace(/^\/([^\/]*).*$/, '$1');
	const normalParams = ['products', 'collections', 'pages', 'account', 'search'];
	return normalParams.includes(firstParam) ? '' : firstParam;
};

const localizedProductUrl = productHandle =>
	localizedRootUrl() ? `/${localizedRootUrl()}/products/${productHandle}` : `/products/${productHandle}`;

const localizedCollectionUrl = collectionHandle =>
	localizedRootUrl() ? `/${localizedRootUrl()}/collections/${collectionHandle}` : `/collections/${collectionHandle}`;

// TODO - rework demographic params
const generateBaseFrameURL = ({ baseColor, lensColor, productHandle, customerJourney, collectionName }) => {
	return `${localizedProductUrl(productHandle)}?${
		customerJourney !== 'default' ? `view=${customerJourney}&` : ''
	}base_color=${baseColor}${
		customerJourney === 'sun_lens' ? `&lens-color=${encodeURIComponent(capitalizeFirstLetter(lensColor))}` : ''
	}&adult=default&${getCollectionQueryParam(collectionName)}`;
};

const getCustomerDemo = () => {
	if (getUrlParameter('men')) return 'men';
	if (getUrlParameter('women')) return 'women';
	if (getUrlParameter('kids')) return 'kids';
	return 'women';
};

const getUrlJourney = () => {
	const journey = getUrlParameter('view');
	if (journey === 'blue_light') return 'blue-light';
	if (journey === 'sun_lens') return 'sunglasses';

	return 'eyeglasses';
};

const getCustomerJourney = () => {
	const journey = getUrlParameter('view');
	if (journey === 'blue_light') return 'BLUE_LIGHT';
	if (journey === 'sun_lens') return 'SUN_LENS';

	return 'DEFAULT';
};

const checkBaseFrameUrl = ({ type, url }) => (type === PRODUCT_TYPES.BASE_FRAME ? `${url}&view=base_frame` : url);

const getUrlParam = name => {
	name = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
	let regex = new RegExp('[\\?&]' + name + '=([^&#]*)');
	let results = regex.exec(location.search);
	return results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '));
};

export {
	checkBaseFrameUrl,
	generateBaseFrameURL,
	getCustomerDemo,
	getUrlJourney,
	getUrlParam,
	getCustomerJourney,
	localizedCollectionUrl,
	localizedProductUrl,
	localizedRootUrl,
};
